const formFunctions =  {
    apiLogin: async function(payload) {
        let response = await
            axios.post('/portal/member/login', payload)
                .then(res => {
                    // console.log('form/functions->apiLogin()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    // apiGetPasswordCode: async function(payload) {
    //     let response = await
    //         axios.post('/portal/member/password/code', payload)
    //             .then(res => {
    //                 if(!!res.data) {
    //                     return res.data;
    //                 }
    //             }).catch(err => {
    //                 console.log(err)
    //                 return 'fail';
    //             });

    //     return response;
    // },
    // apiResetPassword: async function(payload) {
    //     let response = await
    //         axios.post('/portal/member/password/reset', payload)
    //             .then(res => {
    //                 if(!!res.data) {
    //                     return res.data;
    //                 }
    //             }).catch(err => {
    //                 console.log(err)
    //                 return 'fail';
    //             });

    //     return response;
    // },
    apiGetQuiz: async function(payload) {
        let response = await
            axios.post('/portal/member/quiz/get', payload)
                .then(res => {
                    // console.log('form/functions->apiGetQuiz()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiGetVerified: async function(payload) {
        let response = await
            axios.post('/portal/member/quiz', payload)
                .then(res => {
                    // console.log('form/functions->apiGetVerified()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiCreateAccount: async function(payload) {
        let response = await
            axios.post('/portal/member', payload)
                .then(res => {
                    // console.log('form/functions->apiCreateAccount()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiSubmitApplication: async function(payload) {
        let response = await
            axios.post('/portal/member/application', payload)
                .then(res => {
                    // console.log('form/functions->apiSubmitApplication()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiGetScore: async function(payload) {
        let response = await
            axios.post('/portal/member/score/get', payload)
                .then(res => {
                    // console.log('form/functions->apiGetScore()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiStoreFlinks: async function(payload) {
        let response = await
            axios.post('/portal/flinks', payload, {timeout:4000})
                .then(res => {
                    // console.log('form/functions->apiGetScore()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                    console.log(err)
                    return 'fail';
                });

        return response;
    },
    apiHasFlinks: async function(payload) {
        let response = await
            axios.post('/portal/flinks/exists', payload, {timeout:4000})
                .then(res => {
                    // console.log('form/functions->apiGetScore()', res.data);
                    if(!!res.data.status) {
                        return res.data;
                    }
                }).catch(err => {
                console.log(err)
                return 'fail';
            });

        return response;
    },
}

const portalLogin = async (payload) => {

    await axios.get(payload.baseUrl + '/sanctum/csrf-cookie');

    let attemptLogin = await axios.post(payload.baseUrl+'/auth/portal').then(resp => {
        // console.log('attemptLogin');
        return !!resp.status && resp.status == 200 ? false : true;
    }).catch(function (error) {
        if(error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if(error.response.status == 401) {
                // Unauthorized, so lets attempt to log in the user
                return true;
            }
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
        } else if(error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
        }
        // console.log(error.config);
        return false;
    });

    if( !!attemptLogin ) {
        await axios.post(payload.baseUrl + '/login', {
            email: payload.email,
            password: payload.password
        }).then(response => {
            // console.log('response:::login')
            // console.log(response);
        }).catch(error => {
            // console.log(error);
        });
    }

}

export { formFunctions, portalLogin }
